<template>
  <div class="form-check pl-0 relativeChekBox">
    <label class="checkboxArea align-items-center" :class="disabled ? 'disabled' : null">
      <span class="checkboxText">{{ text }}</span>
      <input
        v-model="displayModel"
        :aria-label="'displayModelCheckbox' + uuidv4"
        type="checkbox"
        :checked="checked"
        :disabled="disabled"
        @click="clickEvent($event)"
        @change="changeEvent($event)"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
import BaseModelEmitter from "../../../mixins/baseModelEmitter";
import helper from "../../../util/helper";

export default {
  name: "BaseCheckBox",
  mixins: [BaseModelEmitter, helper],
  props: {
    //eslint-disable-next-line vue/require-default-prop
    inputModel: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickEvent(event) {
      this.$emit("clickEvent", event);
    },
    changeEvent(event) {
      this.$emit("changeEvent", event.target.checked);
    },
  },
};
</script>

<style scoped lang="scss"></style>
